export enum ErrorType {
  DELIVERY_API_ERROR = 'delivery api error',
  BESPOKE_DELIVERY_API_ERROR = 'bespoke delivery api error',
  BESPOKE_DELIVERY_UNAVILABLE = 'bespoke delivery unavailable',
  DELIVERY_UNAVILABLE = 'delivery unavailable',
  SUPPLIER_TO_ARRANGE = 'Supplier to arrange',
}
